import type { CreateTestAliasInput, ImportEntity, ImportStructure } from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';
import { RESOURCE } from '#client/lib/routes';

/** Uploads a workbook as a new import run of `entity`. */
export function uploadWorkbook(entity: ImportEntity, file: File): Promise<ImportStructure> {
  const form = new FormData();
  form.append('entity', entity);
  // The file goes last. Multer streams the parts in order and reads text
  // fields into memory as it goes, so `entity` has to be on the wire before
  // the megabytes or the route handler sees it undefined.
  form.append('file', file);
  return api.upload<ImportStructure>(RESOURCE.imports, form);
}

/** Teaches the importer that a spelling in old sheets means a catalogue test. */
export function createTestAlias(input: CreateTestAliasInput): Promise<unknown> {
  return api.post<unknown>(ENDPOINT.testAliases, input);
}
